<template>
  <div id="app" class="" :style="styleVars">
    <div class="header">
      <div class="container mx-auto px-3">
        <h1 class="text-4xl font-bold py-6 md:py-0">Your {{ env.VUE_APP_BRAND_NAME }} Selections</h1>
        <img v-if="env.VUE_APP_BRAND_LOGO" class="" :src="env.VUE_APP_BRAND_LOGO">
        <img v-else class="absolute right-0 top-0" src="@/assets/images/avid-logo.png" alt="Avid Property Group">
      </div>
    </div>
    <transition name="fade">
      <v-loader v-if="isLoading"/>
    </transition>
    <transition name="fade">
      <div v-if="!isLoading && !isValidFavourites" class="text-center mb-6 flex items-center justify-center" style="height:30vh;">No properties to display.</div>
    </transition>
    <transition name="fade">
      <v-favourites style="flex-grow: 1;" v-if="!isLoading && isValidFavourites"/>
    </transition>
    <v-footer/>
    <transition name="fade">
      <lead-form-modal
        v-if="!isLoading && isValidFavourites && !isReturningUser && isLeadFormTimeoutFinished && !isLeadFormSubmitted"
        @submitted="isLeadFormSubmitted = true"
      />
    </transition>
  </div>
</template>

<script>
import LeadFormModal from './components/LeadFormModal'
import VLoader from './components/VLoader'
import VFavourites from './components/VFavourites'
import VFooter from './components/VFooter'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'App',
  components: {
    LeadFormModal,
    VLoader,
    VFavourites,
    VFooter
  },

  data () {
    return {
      isLeadFormSubmitted: false
    }
  },

  computed: {
    ...mapGetters([
      'isLeadFormTimeoutFinished',
      'isLoading',
      'isReturningUser',
      'isValidFavourites',
    ]),

    env () {
      return process.env
    },

    styleVars () {
      return {
        '--brand-color': process.env.VUE_APP_BRAND_COLOR
      }
    }
  },

  created () {
    this.fetchProperties()
  },

  methods: {
    ...mapActions([
      'fetchProperties'
    ])
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/_fonts';
@import '@/assets/styles/_variables';

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // background-color: $navy;
  color: $body-text-color;
  font-family: $font-sans;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.font-serif {
  font-family: $font-serif
}

.header {
  background-color: $brand-color;
  color: #fff;
  margin-bottom: 30px;
  padding: 30px 0;

  > div {
    align-items: center;
    display: flex;
    justify-content: space-between;

    @media (max-width: 600px) {
      flex-direction: column-reverse;
      text-align: center;
      
      img {
        margin-bottom: 20px;
      }
    }
  }

  img {
    object-fit: contain;
    width: 100px;

    @media (min-width: 768px) {
      width: 180px;
    }
  }
}
</style>
